module.exports = __webpack_public_path__ + "img/hk.665db1dd.png";